import { Close, Save } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonButton from 'components/ArgonButton'
import ArgonInput from 'components/ArgonInput'
import ArgonTypography from 'components/ArgonTypography'
import { postSubmit } from 'global/postFunc'
import React, { useEffect, useState } from 'react'

const Edit = ({
    open,
    handleCloseDialog,
    editData,
    decryptedUser,
    updating,
    setUpdating,
    addReq
}) => {
    const [kode, setKode] = useState('')
    const [uraian, setUraian] = useState('')
    const [kinerja, setKinerja] = useState('')
    const [indikator, setIndikator] = useState('')
    const [satuan, setSatuan] = useState('')

    const [saving, setSaving] = useState(false)

    useEffect(() => {
        if (open) {
            setKode(editData.kode)
            setUraian(editData.uraian)
            setKinerja(editData.kinerja)
            setIndikator(editData.indikator)
            setSatuan(editData.satuan)
        }
    }, [editData, open])

    const submit = (e) => {
        e.preventDefault();
        setSaving(true)
        addReq()
        postSubmit(
            '/sa/kodefikasi-perencanaan/update/' + kode,
            {
                // id_sub_rincian_objek: `${parentData.id}-${subRincianObjekBl.kd_sub_rincian_objek}`,
                _method: 'PUT',
                kode: kode,
                uraian: uraian,
                kinerja: kinerja,
                indikator: indikator,
                satuan: satuan,
            },
            decryptedUser,
            (res) => {
                setSaving(false)
                handleCloseDialog()
                setUpdating(!updating)
            },
            (res) => {
                setSaving(false)
                // setOpen(false)
            }
        )
        // console.log('submit');
    }

    return (
        <Dialog
            open={open}
            maxWidth="md"
            fullWidth
            scroll='paper'
            p={3}
            component='form'
            onSubmit={submit}
        >
            <DialogTitle>
                <ArgonTypography variant='body2' fontWeight="bold">Edit {editData.kode} {editData.uraian}</ArgonTypography>
            </DialogTitle>
            <DialogContent p={3}>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Kode
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        type="text"
                        required
                        size="medium"
                        value={kode}
                        disabled
                        autoComplete='off'
                    />
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Uraian
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        type="text"
                        required
                        size="medium"
                        value={uraian}
                        onChange={(e) => setUraian(e.target.value)}
                        autoComplete='off'
                    />
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Kinerja
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        type="text"
                        required
                        size="medium"
                        value={kinerja}
                        onChange={(e) => setKinerja(e.target.value)}
                        autoComplete='off'
                    />
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Indikator
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        type="text"
                        required
                        size="medium"
                        value={indikator}
                        onChange={(e) => setIndikator(e.target.value)}
                        autoComplete='off'
                    />
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Satuan
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        type="text"
                        required
                        size="medium"
                        value={satuan}
                        onChange={(e) => setSatuan(e.target.value)}
                        autoComplete='off'
                    />
                </ArgonBox>
            </DialogContent>
            <DialogActions>
                <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                    <Grid item>
                        <ArgonButton color='info' variant='outlined' size="small" startIcon={<Close />} onClick={handleCloseDialog}>Batal</ArgonButton>
                    </Grid>
                    <Grid item>
                        <LoadingButton color='info' variant='contained' size="small" startIcon={<Save />} type='submit' loading={saving}>Simpan</LoadingButton>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default Edit